import _styled from "../../../../_snowpack/pkg/styled-components.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useRef, useEffect, useCallback, useState } from '../../../../_snowpack/pkg/react.js';
import { NavLink } from '../../../../_snowpack/pkg/react-router-dom.js';
import { useHistory } from '../../../../_snowpack/pkg/react-router-dom.js';
import hotkeys from '../../../../_snowpack/pkg/hotkeys-js.js';
import classNames from '../../../../_snowpack/pkg/classnames.js';
import { Icon, IconNew, Tooltip } from '../../../css/index.js';
import { useLanguage, useTenantLanguages } from '../../../hooks/index.js';
import { useMedia } from '../../../gates/media-gate.js';
import { useFeatureFlags } from '../../../hooks/index.js';
import { LogoContainer, Wrapper, Multilingual, Heading5, SearchWrapper, Shortcut, Pin } from './styles.js';
import Logo from '../../../images/logo-black.svg';
import TenantMenu from '../navbar/tenant-menu/index.js';
import LanguageMenu from '../navbar/language-menu/index.js';
import SearchMenu from './search/index.js';

var _StyledButton = _styled("button").withConfig({
  displayName: "sidebar___StyledButton",
  componentId: "sc-1w6r60r-0"
})(["cursor:", ";"], p => p._css);

function SideBar(props, ref) {
  const {
    toggleSideBar,
    closeSideBar,
    pinned,
    togglePinnedSidebar
  } = props;
  const history = useHistory();
  const historyRef = useRef();
  const {
    language
  } = useLanguage();
  const availableLanguages = useTenantLanguages();
  const [openSearchAt, setOpenSearchAt] = useState(null);
  const [openLanguage, setOpenLanguage] = useState(false);
  const media = useMedia();
  const featureFlags = useFeatureFlags();
  const selectedLang = availableLanguages.find(lang => {
    return lang.code === language;
  });
  const listenForHistoryChange = useCallback(() => {
    closeSideBar();
  }, [closeSideBar]);
  useEffect(() => {
    historyRef.current = history.listen(listenForHistoryChange);
    return () => {
      historyRef.current();
    };
  }, [history, listenForHistoryChange]);
  useEffect(() => {
    /**
     * this is a hack in order to have it working with the / character,
     * since using the / directly doesn't work/trigger the hotkey
     */
    const keyPattern = '*';

    function onKeyMatch(event) {
      if (event.key === '/') {
        event.preventDefault();
        setOpenSearchAt(Date.now());
      }
    }

    hotkeys(keyPattern, onKeyMatch);
    return () => {
      hotkeys.unbind(keyPattern, onKeyMatch);
    };
  }, []);

  const handleToggleSearch = event => {
    event.stopPropagation();
    setOpenSearchAt(s => {
      if (s) {
        return null;
      }

      return Date.now();
    });
  };

  const handleCloseSearch = event => {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    setOpenSearchAt(null);
  };

  const handleToggleLanguage = event => {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    setOpenLanguage(value => !value);
  };

  const isXlg = media === null || media === void 0 ? void 0 : media.includes('xlg');
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: classNames('sidebar', {
      pinned
    }),
    ref: ref,
    "data-cypress": "sidebar"
  }, /*#__PURE__*/React.createElement(Pin, {
    className: "pin",
    onClick: togglePinnedSidebar,
    "data-cypress": "pin-sidebar",
    title: `${pinned ? 'Unpin' : 'Pin'} sidebar`
  }, /*#__PURE__*/React.createElement(Icon.Pin, null)), /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement(_StyledButton, {
    type: "button",
    onClick: isXlg && pinned ? undefined : toggleSideBar,
    "data-cypress": "expand-sidebar",
    _css: isXlg && pinned ? 'default' : 'pointer'
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    alt: "Crystallize logo",
    "data-cypress": 'crystallize-icon'
  })), /*#__PURE__*/React.createElement(TenantMenu, null)), /*#__PURE__*/React.createElement("div", {
    className: "menu"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/",
    exact: true,
    strict: true
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Dashboard, _extends({}, props, {
      "data-cypress": 'dashboard-icon'
    }))
  }, "Dashboard"), /*#__PURE__*/React.createElement(Heading5, null, "Dashboard"))), featureFlags.applicationPlugins && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/plugins",
    strict: true
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Dashboard, _extends({}, props, {
      "data-cypress": 'dashboard-icon'
    }))
  }, "Plugins"), /*#__PURE__*/React.createElement(Heading5, null, "Plugins")))), /*#__PURE__*/React.createElement("h4", null, "Create"), /*#__PURE__*/React.createElement("ul", {
    className: "menu-group create"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/catalogue"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Catalogue, _extends({}, props, {
      "data-cypress": 'catalogue-icon'
    }))
  }, "Catalogue"), /*#__PURE__*/React.createElement(Heading5, null, "Catalogue"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/topics"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Topics, _extends({
      color: "green"
    }, props, {
      "data-cypress": 'topics-icon'
    }))
  }, "Topics"), /*#__PURE__*/React.createElement(Heading5, null, "Topics"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/grids"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Grid, _extends({
      color: "green"
    }, props, {
      "data-cypress": 'grids-icon'
    }))
  }, "Grids"), /*#__PURE__*/React.createElement(Heading5, null, "Grids")))), /*#__PURE__*/React.createElement("h4", null, "Manage"), /*#__PURE__*/React.createElement("ul", {
    className: "menu-group manage"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/orders"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Order, _extends({}, props, {
      "data-cypress": 'orders-icon'
    }))
  }, "Orders"), /*#__PURE__*/React.createElement(Heading5, null, "Orders"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/fulfilment"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Fulfilment, _extends({}, props, {
      "data-cypress": 'pipelines-icon'
    }))
  }, "Fulfilment"), /*#__PURE__*/React.createElement(Heading5, null, "Fulfilment"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/insight"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Usage, _extends({}, props, {
      "data-cypress": 'insight-icon'
    }))
  }, "Insight"), /*#__PURE__*/React.createElement(Heading5, null, "Insight"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/customers"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.UserAccount, _extends({}, props, {
      "data-cypress": 'customers-icon'
    }))
  }, "Customers"), /*#__PURE__*/React.createElement(Heading5, null, "Customers")))), /*#__PURE__*/React.createElement("h4", null, "Build"), /*#__PURE__*/React.createElement("ul", {
    className: "menu-group build"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/webhooks"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Hooks, _extends({
      color: "green"
    }, props, {
      "data-cypress": 'webhooks-icon'
    }))
  }, "Webhooks"), /*#__PURE__*/React.createElement(Heading5, null, "Webhooks"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/shapes"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Shapes, _extends({}, props, {
      "data-cypress": 'shapes-icon'
    }))
  }, "Shapes"), /*#__PURE__*/React.createElement(Heading5, null, "Shapes"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/subscription-plans"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(IconNew.EmptyCalendar, _extends({
      size: 30
    }, props, {
      "data-cypress": 'subscriptions-icon'
    }))
  }, "Subscription Plans"), /*#__PURE__*/React.createElement(Heading5, null, "Subscription Plans"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/catalogue-explorer"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.GraphQL, _extends({}, props, {
      "data-cypress": 'graphql-explorer-icon'
    }))
  }, "Catalogue Explorer"), /*#__PURE__*/React.createElement(Heading5, null, "Explorer")))), /*#__PURE__*/React.createElement("ul", {
    className: "menu-group settings"
  }, /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Magnifier, _extends({}, props, {
      onClick: handleToggleSearch,
      "data-cypress": 'search-icon'
    }))
  }, !openSearchAt && /*#__PURE__*/React.createElement(React.Fragment, null, "Global search ", /*#__PURE__*/React.createElement(Shortcut, null, "/"))), /*#__PURE__*/React.createElement(Heading5, null, "Search"), /*#__PURE__*/React.createElement(SearchMenu, {
    isOpen: openSearchAt,
    handleClose: handleCloseSearch
  })), /*#__PURE__*/React.createElement(Multilingual, null, /*#__PURE__*/React.createElement(Tooltip, {
    theme: openLanguage ? 'light' : 'dark',
    stayOpen: openLanguage,
    render: props => /*#__PURE__*/React.createElement(Icon.Multilingual, _extends({
      role: "button"
    }, props, {
      onClick: handleToggleLanguage,
      "data-cypress": 'language-icon'
    }))
  }, openLanguage ? /*#__PURE__*/React.createElement(LanguageMenu, {
    handleClose: handleToggleLanguage
  }) : 'Language'), /*#__PURE__*/React.createElement(Heading5, null, selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.name)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/settings"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    theme: "dark",
    render: props => /*#__PURE__*/React.createElement(Icon.Cog, _extends({}, props, {
      "data-cypress": 'settings-icon'
    }))
  }, "Settings"), /*#__PURE__*/React.createElement(Heading5, null, "Settings"))))));
}

export default /*#__PURE__*/forwardRef(SideBar);